export const isContainerBlock = (block) => {
    return block.name === 'Container';
};
export const isColumnBlock = (name) => name === 'Columns';
export const isDeprecatedBlock = (name) => name !== 'Container';
//# sourceMappingURL=utils.js.map